import React, { FC } from 'react'
import { ICard } from '@mobx/pay/pay.mobx'
import { format } from '@dt/fe-utils'
import { shortCardNumber } from '../util'

interface ICardItemProps {
  card: ICard;
  isCurrent?: boolean;
  disabled?: boolean;
  onSelect?(): void;
}

const CardItem: FC<ICardItemProps> = ({ card, isCurrent, disabled, onSelect }) => {
  return (
    <li className={'gift-card' + (isCurrent ? ' current' : '')} onClick={onSelect}>
      <span>{shortCardNumber(card.number)}</span>
      <span className='balance'>{format.toPrice(card.balance)}</span>
    </li>
  )
}

export default CardItem
